import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Mainmenu from '../../Shared/Mainmenu/Mainmenu';
import Form from '../Form/Form';

const Contact = () => {
    return (
        <>
            <Mainmenu/>
            <Form/>
            <Footer/>
        </>
    );
};

export default Contact;